import React from 'react';
import styles from './CustomPopconfirm.module.scss';
import { Popconfirm } from 'antd';
import { ReactComponent as InfoIcon } from '../../../../../../../resource/InfoIcon.svg';

const CustomPopconfirm = ({ children, icon = <InfoIcon />, ...props }) => {
  return (
    <Popconfirm
      overlayClassName={styles.customPopconfirm}
      icon={icon}
      {...props}
    >
      {children}
    </Popconfirm>
  );
};

export default CustomPopconfirm;
